import Config from 'Config';
import { refreshToken } from '../auth/actions';
import { getDefaultRequestHeaders } from '../common/middleware/api';
import { fetchFranchisorSettings } from '../dashboard/settings/franchisor/actions';
import { loadLanguages } from '../languages/actions';
import { loadReleaseNotes } from '../dashboard/default/releaseNotes/actions';
import { loadMessageTemplateTags } from '../dashboard/messageTemplates/actions';
import globalize, { i18n } from '../common/services/globalize';
import analyticsTracker from '../common/services/analyticsTracker';
import authUtils from '../auth/utils';

export const FRANCHISOR_REQUEST = 'FRANCHISOR_REQUEST';
export const FRANCHISOR_SUCCESS = 'FRANCHISOR_SUCCESS';
export const FRANCHISOR_FAILURE = 'FRANCHISOR_FAILURE';

export const LOOKUPS_REQUEST = 'LOOKUPS_REQUEST';
export const LOOKUPS_SUCCESS = 'LOOKUPS_SUCCESS';
export const LOOKUPS_FAILURE = 'LOOKUPS_FAILURE';

const FRANCHISORS_URL = `${Config.backofficeApiUrl}/api/franchisors`;
const LOOKUPS_URL = `${Config.backofficeApiUrl}/api/lookups`;

const requestFranchisor = () => ({
	type: FRANCHISOR_REQUEST
});

const receiveFranchisor = (json) => ({
	type: FRANCHISOR_SUCCESS,
	payload: { ...json }
});

const franchisorError = () => ({
	type: FRANCHISOR_FAILURE
});

export const initCurrentFranchisor = () => (dispatch, getState) => {
	dispatch(requestFranchisor());
	const config = {
		headers: {
			...getDefaultRequestHeaders(getState()),
			'X-Franchisor-Id': null
		}
	};
	return fetch(`${FRANCHISORS_URL}?backOfficeUrl=${encodeURIComponent(window.location)}`, config)
		.then(response => response.json().then(franchisor => {
			if (!response.ok) {
				dispatch(franchisorError());
			} else {
				globalize.init(franchisor);

				const googleAnalyticsAdminCode = franchisor.enableGoogleAnalyticsAdmin ? franchisor.googleAnalyticsAdminCode : '';
				analyticsTracker.initAnalyticsTracking({ googleAnalyticsAdminCode });

				if (franchisor.customResourcesFile) {
					const customNamespace = `franchisor.${franchisor.customResourcesFile}`;
					i18n.loadNamespaces(customNamespace);
					i18n.setDefaultNamespace(customNamespace);
				}

				document.title = i18n.t('Admin_Document_Title', { systemName: franchisor.systemName });

				dispatch(receiveFranchisor(franchisor));
				dispatch(refreshToken(true)).then(success => {
					//if (success) {
						//const { configuration, currentUser } = getState();
						//if (authUtils.hasPermission(currentUser, 'FranchisorSettings')) {
						//	dispatch(fetchFranchisorSettings(configuration.franchisor.id)); //load in refreshToken -> getCurrentUser
						//}
					//}
					// merge-tags catalog is a static per-session lookup; load once, after the access
					// token is ready so the first authorized request doesn't 401 and get retried
					if (success) {
						dispatch(loadMessageTemplateTags());
					}
				});
				dispatch(loadLanguages()).then(() => {
					dispatch(loadLookups());
				});
				dispatch(loadReleaseNotes(franchisor.releaseNotesUrl));
			}
		}));
};

const requestLookups = () => ({
	type: LOOKUPS_REQUEST
});

const receiveLookups = (json) => ({
	type: LOOKUPS_SUCCESS,
	payload: { ...json }
});

const lookupsError = () => ({
	type: LOOKUPS_FAILURE
});

export const loadLookups = () => (dispatch, getState) => {
	dispatch(requestLookups());
	const config = {
		headers: getDefaultRequestHeaders(getState())
	};
	return fetch(LOOKUPS_URL, config)
		.then(response => response.json().then(json => {
			if (!response.ok) {
				dispatch(lookupsError());
			} else {
				dispatch(receiveLookups({
					...json,
					referralSourceTypes: json.referralSourceTypes.map(t => ({
						id: t.id,
						name: t.name,
						displayName: i18n.t(`ReferralSourceType_${t.name}`)
					}))
				}));
			}

		}));
};